export default import.meta.ROLLDOWN_FILE_URL_7uQjjO3hz61BTD3uZte2zg